import { render, staticRenderFns } from "./LocumSuccessBookingRejected.vue?vue&type=template&id=545cce7e&"
import script from "./LocumSuccessBookingRejected.vue?vue&type=script&lang=js&"
export * from "./LocumSuccessBookingRejected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports